<template>
  <lk-spin fix>
    <lk-icon custom="iconfont i-icon-loading" size=36 class="demo-spin-icon-load"></lk-icon>
  </lk-spin>
</template>
<script>
export default {
  name: 'AnSpin',
};
</script>

<style lang="less" scoped>
  @keyframes ani-demo-spin {
      from { transform: rotate(0deg);}
      50%  { transform: rotate(180deg);}
      to   { transform: rotate(360deg);}
  }
  .demo-spin-icon-load{
      animation: ani-demo-spin 2s linear infinite;
  }
  .i-icon-loading{
    color: #444;
  }
  .i-icon-loading:before {
    content: "\e634";
  }
</style>
